import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import "./registerServiceWorker";
import "./didomi";
import BootstrapVue from 'bootstrap-vue';
import './assets/custom.scss';
import axios from 'axios';

import Default from "./layouts/Default.vue";
import Admin from "./layouts/Admin.vue";

Vue.use(BootstrapVue);
Vue.config.productionTip = false;

// Before you create app
Vue.config.debug = process.env.NODE_ENV === 'development';
Vue.config.devtools = process.env.NODE_ENV === 'development';

Vue.component('default-layout', Default);
Vue.component('admin-layout', Admin);

const token = localStorage.getItem('user-token');
if (token) {
  axios.defaults.headers.common['Authorization'] = token;
}

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");

// After you create app
if (process.env.NODE_ENV === 'development') {
  window.__VUE_DEVTOOLS_GLOBAL_HOOK__.Vue = App.constructor;
}